import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Platform } from 'ionic-angular';
import { HomePage } from "../home/home";
import { ScanPage } from "../scan/scan";
import { LoginPage } from "../login/login";
import { AuraMainPage } from "../aura-main/aura-main";
import { ChartGlowPage } from "../chart-glow/chart-glow";
import { AgeGatePage } from '../age-gate/age-gate';
import { AuthService } from "../../providers/auth/auth.service";
import { AppProvider } from "../../providers/app/app";
import { EvtProvider } from "../../providers/evt/evt";
/**
 * This is the catch-all page. All paths are checked here first.
 * The access_token and id_token variables are stored in localstorage
 * for processing.
 *
 */

@IonicPage()
@Component({
  selector: 'page-auth',
  templateUrl: 'auth.html',
})
export class AuthPage {
  isNotLoggedIn: boolean = true;
  frmPage: any = AuraMainPage;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public app: AppProvider,
    private auth0: AuthService,
    public loader: LoadingController,
    public platform: Platform,
    public evt: EvtProvider) {
    if(localStorage.getItem('loginPgSrc') == "chart-your-glow"){
      console.log('to chart or not to chart');
      this.frmPage = ChartGlowPage;
    }
  }
  ionViewDidLoad() { }
  ngOnInit() {

    let data = this.navParams.get('data');
    console.log(data);

    if (data === "" || !this.platform.is('mobile')) {
      //experience starts with SCAN page (HomePage)
      this.navCtrl.setRoot(HomePage);

    } else if (this.URLToArray(data).hasOwnProperty('thng')) {

      let pData = this.URLToArray(data);
      //there's a THNG
      this.navCtrl.setRoot(ScanPage, {
          thng: pData["thng"]
        }
      );

    } else {

      let load = this.loader.create({
        spinner: 'crescent',
        dismissOnPageChange: true,
        showBackdrop: true,
        content: `Please wait...`,
        enableBackdropDismiss:false});

      load.present();

      let authData = this.URLToArray(data);
      this.auth0.result(authData).then(res => {
        console.log(res);

        if(localStorage.regFB === "true"){
          this.app.startReg('facebook');
          localStorage.removeItem('regFB');
        }
        
        if(res == "deleted_user"){
          this.navCtrl.setRoot(LoginPage, {isUserDeleted: true});
        }else{

          this.app.completeReg(res).then(reg=> {
            if (reg === false) {
              //try logging in
              this.app.completeLogin(res).then(login=>{
                if (login !== false) {

                  this.navCtrl.setRoot(this.frmPage);
                  localStorage.removeItem('loginPgSrc');

                } else {

                  this.navCtrl.setRoot(HomePage);

                }

              }).catch(rest=>{console.info('completeLogin',rest);});

            } else {

              this.navCtrl.setRoot(this.frmPage);
              localStorage.removeItem('loginPgSrc');
            }

          }).catch(rest=>{console.info('completeReg',rest);});

        }


      }).catch(err => {
        console.log(err);
        //GO TO ERROR PAGE
      })
    }
  }

  URLToArray(url: string) {

    var request = {};
    var pairs = url.split('&');
    for (var i = 0; i < pairs.length; i++) {
      if (!pairs[i])
        continue;
      var pair = pairs[i].split('=');
      request[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return request;

  }

  gotoNexPage() {

    /*check if age gate*/
    if (this.app.isValidAge()){
      this.navCtrl.setRoot(this.frmPage);
      localStorage.removeItem('loginPgSrc');
    }
    else this.navCtrl.setRoot(AgeGatePage);

  }

}



// WEBPACK FOOTER //
// ./src/pages/auth/auth.ts